/**
 * Detects if the current browser is Instagram's in-app browser
 *
 * Instagram's in-app browser has limited support for CSS environment variables
 * like safe-area-inset-bottom on some platforms (especially Android).
 *
 * @returns true if the user agent indicates Instagram browser
 */
export const isInstagramBrowser = ((): boolean => {
  if (typeof navigator === 'undefined') return false;
  return /Instagram/.test(navigator.userAgent);
})();
